import {ArrowRight, Check} from '@nlabs/gothamjs/icons';
import {Link} from '@nlabs/gothamjs/router';

import {primaryButton} from '../../theme/classes.js';

import type {ReactElement} from 'react';

export const FreePlanningOffer = ({signedIn}: {readonly signedIn: boolean}): ReactElement => (
  <section aria-labelledby="free-planning-heading" className="mt-12 grid gap-8 rounded-[2rem] border border-violet-200/40 bg-linear-to-br from-[#dfd4fb] via-[#c4bdec] to-[#91cfe8] p-7 text-violet-950 sm:p-10 lg:grid-cols-[1fr_auto] lg:items-center">
    <div>
      <p className="text-xs font-semibold tracking-[.15em] uppercase">Your first month starts here</p>
      <h2 className="mt-4 text-4xl tracking-tight sm:text-5xl" id="free-planning-heading">Big ideas. Free to begin.</h2>
      <p className="mt-5 max-w-2xl text-base leading-7 text-violet-950/80">Build your projects, develop your characters, and plan your story. After your first month, keep planning for free or explore one of our three paid memberships.</p>
      <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-3 text-sm font-medium">{['Projects', 'Characters', 'Story planning'].map((feature) => <li className="inline-flex items-center gap-2" key={feature}><Check aria-hidden="true" size={16} />{feature}</li>)}</ul>
      <p className="mt-5 text-sm leading-6 text-violet-950/70">Generation and video storage are paid features. Your free planning access continues, with no automatic upgrade or charge.</p>
    </div>
    <div className="lg:min-w-52">
      <p className="text-6xl font-semibold tracking-tight">$0</p>
      <p className="mt-2 text-sm text-violet-950/70">No card required</p>
      <Link className={`${primaryButton} mt-6`} to={signedIn ? '/account' : '/sign-up'}>{signedIn ? 'Your free account' : 'Start planning free'} <ArrowRight aria-hidden="true" size={16} /></Link>
    </div>
  </section>
);
